import React, { useState, useRef, useEffect } from 'react';
import { Input, FormCustom } from '../../Components/Form/Form'; // Asegúrate de que la ruta es correcta
import Controllers from '../../Api/Controllers';
import Loading from '../../Components/Layout/Styled/Loading';
import Helpers from '../../Components/Helpers/Helpers';
import { toast } from 'react-toastify'

const NumberAndCameraApp = ({ disablebSubmit, loadSubmit }) => {
  const [numberInput, setNumberInput] = useState('');
  /* const [photo, setPhoto] = useState(null); */
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [load, setLoad] = useState(false)

  // Iniciar la cámara
  useEffect(() => {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices.getUserMedia({ video: { facingMode: 'user' } })
        .then((stream) => {
          videoRef.current.srcObject = stream;
          videoRef.current.play();
        })
        .catch((err) => {
          console.error("Error accessing camera: ", err);
          alert("No se pudo acceder a la cámara. Verifica los permisos.");
        });
    }
  }, []);

  // Agregar número al input
  const appendNumber = (num) => {
    setNumberInput((prev) => prev + num);
  };

  // Borrar toda la cadena
  const clearAll = () => {
    setNumberInput('');
  };

  // Borrar el último carácter
  const clearLastChar = () => {
    setNumberInput((prev) => prev.slice(0, -1));
  };

  // Capturar la foto desde el video
  const capturePhoto = () => {
    if (!numberInput) {
      Helpers.toast.construct({ response: 'warning', message: 'Ingresa un número primero.', toast });
      return;
    }

    const canvas = canvasRef.current;
    const video = videoRef.current;
    const context = canvas.getContext('2d');

    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    context.drawImage(video, 0, 0, canvas.width, canvas.height);
    const photoData = canvas.toDataURL('image/png');
    console.log(photoData)
    /* setPhoto(photoData); */

    setLoad(true)
    const formData = new FormData();
    formData.append('p_id_employee', numberInput);
    if (photoData) {
      const blob = dataURLtoBlob(photoData); // Usa photoData en lugar de photo
      formData.append('p_photo', blob);
    }
    Controllers.employee.attendance(formData).then(res => {
      Helpers.toast.construct({ ...res, toast })
      clearAll()
      if (res.response === 'success') {
        /* setPhoto(null) */
      }
    }).catch(req => Helpers.promise.catch({ req, toast }))
      .finally(() => {
        setLoad(false)
      })
  };

  // Utility function to convert base64 image to Blob
  const dataURLtoBlob = (dataurl) => {
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  };

  return (
    <>
      <div className="d-flex justify-content-center mt-5">
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title text-center mb-3">Marca tu asistencia
              </h5>

              <FormCustom disablebSubmit={disablebSubmit} loadSubmit={loadSubmit} viewSubmit={false}>

                {/* Input readonly para mostrar los números ingresados */}
                <Input
                  text="Código"
                  placeholder="Código"
                  classNameParent="col-12 mb-4"
                  icon="far fa-keyboard"
                  required
                  invalid="Los números son obligatorios."
                  defaultValue={numberInput}
                  readOnly
                />

                {/* Botones del 0 al 9 organizados en filas de 3 en 3 */}
                <div className="col-12">
                  <div className="row mb-3">
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 0].map((num, index) => (
                      <div key={num} className="col-4 mb-2">
                        <button className="btn btn-primary w-100" onClick={() => appendNumber(num)}>
                          {num}
                        </button>
                      </div>
                    ))}
                    <div className="col-4 mb-2">
                      <button className="btn btn-danger w-100" onClick={clearAll}>
                        <i className="fas fa-trash"></i>
                      </button>
                    </div>
                    <div className="col-4 mb-2">
                      <button className="btn btn-warning w-100" onClick={clearLastChar}>
                        <i className="fas fa-backspace"></i>
                      </button>
                    </div>
                  </div>
                </div>

                {/* Botones de borrar todo y borrar el último carácter */}


                <div className="col-12">
                  {/* Botón para capturar la foto */}
                  <div className="text-center mb-3">
                    <button className="btn btn-success" onClick={capturePhoto}>
                      <i className="fas fa-user"></i> Marcar Asistencia
                    </button>
                  </div>

                  {/* Div para mostrar la imagen capturada */}
                  {/* photo && (
                    <div className="text-center mb-3">
                      <img src={photo} alt="Captured" className="img-fluid rounded" />
                    </div>
                  ) */}

                  {/* Video oculto para capturar la cámara */}
                  <div className="d-none">
                    <video ref={videoRef} />
                  </div>

                  {/* Canvas oculto para capturar la imagen */}
                  <canvas ref={canvasRef} style={{ display: 'none' }}></canvas>
                </div>
              </FormCustom>
            </div>
          </div>
        </div>
      </div>
      <Loading show={load}>
        <Loading.Img src={Helpers.config.resourcesUrl({ url: '/images/dashboard/preloading.svg' })} alt="Preloading" />
      </Loading>
    </>
  );
};

NumberAndCameraApp.defaultProps = {
  onSubmit: () => { },
  loadSubmit: false,
};

export default NumberAndCameraApp;
